/**
 * Handles keyboard navigation for accessible interactive elements.
 * Triggers the provided callback when Enter or Space key is pressed.
 *
 * This utility ensures keyboard accessibility for clickable elements that
 * aren't native buttons, following WCAG 2.1 guidelines for keyboard interaction.
 *
 * @param e - The keyboard event from the element
 * @param callback - The function to execute when Enter or Space is pressed
 *
 * @example
 * ```tsx
 * <div
 *   role="button"
 *   tabIndex={0}
 *   onClick={handleClick}
 *   onKeyDown={(e) => handleKeyboardActivation(e, handleClick)}
 * >
 *   Click me
 * </div>
 * ```
 */
export const handleKeyboardActivation = (
  e: React.KeyboardEvent,
  callback: () => void
): void => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    callback();
  }
};
